const MONTH_RECORDS_LIMIT = 2;
const WEEK_RECORDS_LIMIT = 8;

export default {
  monthRecordsLimit: MONTH_RECORDS_LIMIT,
  weekRecordsLimit: WEEK_RECORDS_LIMIT,
};
